import { useQuery } from '@apollo/client/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Statistic from '../Statistic';
import GET_STATS from './queries/GetPersistedTotalMembers';

const TotalMembers = function () {
  const { partnerId } = useParams();
  const { t } = useTranslation();

  const { data, loading } = useQuery(GET_STATS, {
    variables: { partnerId: partnerId! },
  });

  const totalMembers = data?.community?.stats?.totalMembers || 0;

  return (
    <Statistic
      title={t('chat:::members')}
      value={totalMembers}
      loading={loading}
    />
  );
};

export default TotalMembers;
